<div class="portfolio-container">
  <app-agent-companies-list
    [initialLocations]="selectedLocations"
    (selectedLocationsChange)="selectedLocationsChange($event)"
  ></app-agent-companies-list>
  <div class="actions">
    <button type="button" class="back" (click)="previous()">
      <img src="assets/icones/arrow-back-black.svg" alt="" />
      {{ "agent.actions.back" | translate }}
    </button>
    <div style="display: flex; flex-direction: row; gap: 20px">
      <button type="button" class="skip" (click)="next({ skip: true })">
        {{ "agent.actions.skip" | translate }}
      </button>
      <button type="button" class="submit" (click)="next()">
        {{ "agent.actions.proceed" | translate }}
        <img src="assets/icones/arrow-right.svg" alt="" />
      </button>
    </div>
  </div>
</div>
